import { forwardRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState, useRecoilValue } from 'recoil'
import TradingViewChart from '@/components/TradingViewChart'
import MarketList from '@/components/trade/MarketList'
import LastPrice from '@/components/trade/LastPrice'
import MarketTicker from '@/components/trade/MarketTicker'
import { networkState } from '@/recoil/Network'
import { marketSymbolState } from '@/recoil/Market'
import { openOrderListValue } from '@/recoil/OrderList'
import { TRADING_VIEW_CHART_API_ENDPOINT_MAP } from '@/constants/config'

import './MarketChart.css'

export default forwardRef(function MarketChart({ children, ...props }, ref) {
  props = {
    ref,
    ...props,
    className: `${props.className} card noselect market-chart`
  }

  const navigate = useNavigate()
  const [network] = useRecoilState(networkState)
  const [marketSymbol] = useRecoilState(marketSymbolState)
  const openOrderList = useRecoilValue(openOrderListValue)

  const datafeedUrl = TRADING_VIEW_CHART_API_ENDPOINT_MAP[network]
  const onSymbolUpdate = useCallback(
    marketSymbol => navigate(`/trade/${marketSymbol}`),
    [navigate]
  )

  return (
    <div {...props}>
      <div className="market-chart-header card-draggable-area">
        <div className="market-chart-header-container">
          <MarketList />
          <LastPrice showPriceStatusIcon={false} />
          <MarketTicker />
        </div>
      </div>
      <TradingViewChart
        datafeedUrl={datafeedUrl}
        symbol={marketSymbol}
        openOrderList={openOrderList}
        onSymbolUpdate={onSymbolUpdate}
      />
      {children}
    </div>
  )
})
